import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7071/marketing";
	}
	beginMarketingPackage(e, t) {
		let r = this.baseUrl + "/BeginMarketingPackage", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processBeginMarketingPackage(e)));
	}
	processBeginMarketingPackage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	completeMarketingPackageStep(e, t) {
		let r = this.baseUrl + "/CompleteMarketingPackageStep", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCompleteMarketingPackageStep(e)));
	}
	processCompleteMarketingPackageStep(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	createMarketingPackageTemplate(e, t) {
		let r = this.baseUrl + "/CreateMarketingPackageTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateMarketingPackageTemplate(e)));
	}
	processCreateMarketingPackageTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? W("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	deleteMarketingPackageTemplate(e, t) {
		let r = this.baseUrl + "/DeleteMarketingPackageTemplate", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDeleteMarketingPackageTemplate(e)));
	}
	processDeleteMarketingPackageTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	getMarketingItemTemplatesForAgent(e) {
		let t = this.baseUrl + "/GetMarketingItemTemplatesForAgent", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetMarketingItemTemplatesForAgent(e)));
	}
	processGetMarketingItemTemplatesForAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	getMarketingPackage(e, t) {
		let r = this.baseUrl + "/GetMarketingPackage";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'marketingPackageId' must be defined and cannot be null.");
		r += "marketingPackageId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetMarketingPackage(e)));
	}
	processGetMarketingPackage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? W("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	getMarketingPackageTemplatesForAgent(e) {
		let t = this.baseUrl + "/GetMarketingPackageTemplatesForAgent", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetMarketingPackageTemplatesForAgent(e)));
	}
	processGetMarketingPackageTemplatesForAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? W("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	getMarketingPackages(e, t) {
		let r = this.baseUrl + "/GetMarketingPackages";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetMarketingPackages(e)));
	}
	processGetMarketingPackages(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? W("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	loadMarketingPackageForm(e, t) {
		let r = this.baseUrl + "/LoadMarketingPackageForm";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'formId' must be defined and cannot be null.");
		r += "formId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processLoadMarketingPackageForm(e)));
	}
	processLoadMarketingPackageForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	removeMarketingPackageSubmission(e, t) {
		let r = this.baseUrl + "/RemoveMarketingPackageSubmission", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemoveMarketingPackageSubmission(e)));
	}
	processRemoveMarketingPackageSubmission(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	saveMarketingPackage(e, t) {
		let r = this.baseUrl + "/SaveMarketingPackage", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSaveMarketingPackage(e)));
	}
	processSaveMarketingPackage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	sendMarketingPackage(e, t) {
		let r = this.baseUrl + "/SendMarketingPackage", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSendMarketingPackage(e)));
	}
	processSendMarketingPackage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	setMarketingItemTemplates(e, t) {
		let r = this.baseUrl + "/SetMarketingItemTemplates", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetMarketingItemTemplates(e)));
	}
	processSetMarketingItemTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetMarketingItemTemplates(e, t) {
		let r = this.baseUrl + "/StaffGetMarketingItemTemplates";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetMarketingItemTemplates(e)));
	}
	processStaffGetMarketingItemTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetMarketingPackage(e, t) {
		let r = this.baseUrl + "/StaffGetMarketingPackage";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'marketingPackageId' must be defined and cannot be null.");
		r += "marketingPackageId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetMarketingPackage(e)));
	}
	processStaffGetMarketingPackage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetMarketingPackageTemplates(e, t) {
		let r = this.baseUrl + "/StaffGetMarketingPackageTemplates";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetMarketingPackageTemplates(e)));
	}
	processStaffGetMarketingPackageTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetMarketingPackages(e, t) {
		let r = this.baseUrl + "/StaffGetMarketingPackages";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetMarketingPackages(e)));
	}
	processStaffGetMarketingPackages(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	submitMarketingPackage(e, t) {
		let r = this.baseUrl + "/SubmitMarketingPackage", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSubmitMarketingPackage(e)));
	}
	processSubmitMarketingPackage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateMarketingPackageTemplate(e, t) {
		let r = this.baseUrl + "/UpdateMarketingPackageTemplate", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateMarketingPackageTemplate(e)));
	}
	processUpdateMarketingPackageTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? W("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateMarketingPackageTemplateOrder(e, t) {
		let r = this.baseUrl + "/UpdateMarketingPackageTemplateOrder", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateMarketingPackageTemplateOrder(e)));
	}
	processUpdateMarketingPackageTemplateOrder(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : W("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.AdditionalDocumentations = "AdditionalDocumentations", e.AddressSearch = "AddressSearch", e.BuyersAgentSearch = "BuyersAgentSearch", e.AgreementDetails = "AgreementDetails", e.BuildingAndPest = "BuildingAndPest", e.VendorBuyerDetails = "VendorBuyerDetails", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.ContractDeposit = "ContractDeposit", e.DepositPayable = "DepositPayable", e.Dropdown = "Dropdown", e.Date = "Date", e.DateTime = "DateTime", e.TextInput = "TextInput", e.Radio = "Radio", e.InfoLabel = "InfoLabel", e.PropertySearch = "PropertySearch", e.SolicitorSearch = "SolicitorSearch", e.ListingAgentSelector = "ListingAgentSelector", e.Commission = "Commission", e.PersonName = "PersonName", e.Checkbox = "Checkbox", e.MarketingPackage = "MarketingPackage", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.ReviewAndSign = "ReviewAndSign", e.AlternateAddressSearch = "AlternateAddressSearch", e.FileUpload = "FileUpload", e.TenantedProperty = "TenantedProperty", e.TypedDocumentUpload = "TypedDocumentUpload", e.POADocumentUpload = "POADocumentUpload", e.TextArea = "TextArea", e.SaleDetails = "SaleDetails", e.LaunchDetails = "LaunchDetails", e.SpecialConditions = "SpecialConditions", e.YesNoQuestion = "YesNoQuestion", e.SettlementDate = "SettlementDate", e.SendForDocuSigning = "SendForDocuSigning", e.SignboardRemoval = "SignboardRemoval", e.MarketingContributions = "MarketingContributions", e.DisplayPrice = "DisplayPrice", e.PriceSpecification = "PriceSpecification", e.Currency = "Currency", e.SubjectToFinance = "SubjectToFinance", e.AdjustmentToCommission = "AdjustmentToCommission", e.ExternalConjunction = "ExternalConjunction", e.PropertyType = "PropertyType", e.VendorDetailsDisplay = "VendorDetailsDisplay", e.ConditionalTextInput = "ConditionalTextInput", e.SecondaryAgentCommissionSplit = "SecondaryAgentCommissionSplit", e.TenancyDetails = "TenancyDetails", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.LegalDescription = "LegalDescription", e.PropertyAttributes = "PropertyAttributes", e.ChattelsIncluded = "ChattelsIncluded", e.RuralParticulars = "RuralParticulars", e.PriceOpinion = "PriceOpinion", e.EditablePdfUpload = "EditablePdfUpload", e.Deposit = "Deposit", e.CoolingOffPeriod = "CoolingOffPeriod", e.Image = "Image", e.Alerts = "Alerts", e.MarketingConfirmation = "MarketingConfirmation", e.MarketingLaunchDetails = "MarketingLaunchDetails", e.SellersDisclosurePreparedBy = "SellersDisclosurePreparedBy", e.BodyCorporate = "BodyCorporate", e.SellersDisclosureUpload = "SellersDisclosureUpload", e.CommunityTitlesScheme = "CommunityTitlesScheme", e.BodyCorporateRecords = "BodyCorporateRecords", e.SurveyPlanUpload = "SurveyPlanUpload", e.IdentityVerificationExports = "IdentityVerificationExports", e.ContractReplacementUpload = "ContractReplacementUpload", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e.AuthorityToExchange = "AuthorityToExchange", e.MergedContractExchange = "MergedContractExchange", e.ComparableImage = "ComparableImage", e.ProposalImage = "ProposalImage", e.CrmListingPhoto = "CrmListingPhoto", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.And = "And", e.Or = "Or", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Manual = "Manual", e.DocuSign = "DocuSign", e.Email = "Email", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.EQ = "EQ", e.NEQ = "NEQ", e.LT = "LT", e.GT = "GT", e.LTEQ = "LTEQ", e.GTEQ = "GTEQ", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.None = "None", e.ForwardAndBack = "ForwardAndBack", e.BackAndReview = "BackAndReview", e.BackAndSubmit = "BackAndSubmit", e.Forward = "Forward", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Send = "Send", e.GeneratePdf = "GeneratePdf", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e.ListingProposal = "ListingProposal", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e.AuthorityToExchange = "AuthorityToExchange", e.MergedContractExchange = "MergedContractExchange", e.ComparableImage = "ComparableImage", e.ProposalImage = "ProposalImage", e.CrmListingPhoto = "CrmListingPhoto", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Portals = "Portals", e.PrintCollateral = "PrintCollateral", e.Media = "Media", e.SocialAgent = "SocialAgent", e.SocialRexReach = "SocialRexReach", e.Other = "Other", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Price = "Price", e.Complimentary = "Complimentary", e.AgentToFill = "AgentToFill", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Portals = "Portals", e.PrintCollateral = "PrintCollateral", e.Media = "Media", e.SocialAgent = "SocialAgent", e.SocialRexReach = "SocialRexReach", e.Other = "Other", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Price = "Price", e.Complimentary = "Complimentary", e.AgentToFill = "AgentToFill", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Item = "Item", e.Group = "Group", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.ConfirmedLaunchDate = "ConfirmedLaunchDate", e.PropertyOnMarket = "PropertyOnMarket", e.OffMarket = "OffMarket", e.LaunchDateToBeConfirmed = "LaunchDateToBeConfirmed", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.Complete = "Complete", e.Future = "Future", e.FutureDisabled = "FutureDisabled", e.Invalid = "Invalid", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), H = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e.AuthorityToExchange = "AuthorityToExchange", e.MergedContractExchange = "MergedContractExchange", e.ComparableImage = "ComparableImage", e.ProposalImage = "ProposalImage", e.CrmListingPhoto = "CrmListingPhoto", e;
}({}), U = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isMarketingApiException = !0;
	static isMarketingApiException(e) {
		return e.isMarketingApiException === !0;
	}
};
function W(e, t, n, r, i) {
	throw i ?? new U(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var G = "marketing";
function K(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var q = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), K(r);
}, J = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[G] || `${e}/${G}`;
}, Y = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = J(i), u = c, d = q(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = q(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, X = a({}), Z = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = Y(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(X.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, Q = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.beginMarketingPackage(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		beginMarketingPackage: d,
		beginMarketingPackagePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, te = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.completeMarketingPackageStep(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		completeMarketingPackageStep: d,
		completeMarketingPackageStepPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ne = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.createMarketingPackageTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		createMarketingPackageTemplate: d,
		createMarketingPackageTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, re = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.deleteMarketingPackageTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		deleteMarketingPackageTemplate: d,
		deleteMarketingPackageTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ie = (e) => {
	let t = r(12), n = e === void 0 || e, i = o(X), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getMarketingItemTemplatesForAgent"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getMarketingItemTemplatesForAgent(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p, error: m, isFetching: h } = u(l), g;
	return t[6] !== d || t[7] !== m || t[8] !== p || t[9] !== h || t[10] !== f ? (g = {
		data: d,
		isPending: f,
		isError: p,
		error: m,
		isFetching: h
	}, t[6] = d, t[7] = m, t[8] = p, t[9] = h, t[10] = f, t[11] = g) : g = t[11], g;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getMarketingItemTemplatesForAgent", ...n] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["getMarketingPackage", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getMarketingPackage(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getMarketingPackage", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ce = (e) => {
	let t = r(12), n = e === void 0 || e, i = o(X), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getMarketingPackageTemplatesForAgent"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getMarketingPackageTemplatesForAgent(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p, error: m, isFetching: h } = u(l), g;
	return t[6] !== d || t[7] !== m || t[8] !== p || t[9] !== h || t[10] !== f ? (g = {
		data: d,
		isPending: f,
		isError: p,
		error: m,
		isFetching: h
	}, t[6] = d, t[7] = m, t[8] = p, t[9] = h, t[10] = f, t[11] = g) : g = t[11], g;
}, le = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getMarketingPackageTemplatesForAgent", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ue = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["getMarketingPackages", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getMarketingPackages(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, de = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getMarketingPackages", ...n] });
	}, e[0] = t, e[1] = n), n;
}, fe = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["loadMarketingPackageForm", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.loadMarketingPackageForm(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["loadMarketingPackageForm", ...n] });
	}, e[0] = t, e[1] = n), n;
}, me = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.removeMarketingPackageSubmission(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		removeMarketingPackageSubmission: d,
		removeMarketingPackageSubmissionPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, he = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.saveMarketingPackage(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		saveMarketingPackage: d,
		saveMarketingPackagePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ge = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.sendMarketingPackage(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		sendMarketingPackage: d,
		sendMarketingPackagePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, _e = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setMarketingItemTemplates(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setMarketingItemTemplates: d,
		setMarketingItemTemplatesPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ve = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["staffGetMarketingItemTemplates", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetMarketingItemTemplates(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, ye = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["staffGetMarketingItemTemplates", ...n] });
	}, e[0] = t, e[1] = n), n;
}, be = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["staffGetMarketingPackage", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetMarketingPackage(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, $ = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["staffGetMarketingPackage", ...n] });
	}, e[0] = t, e[1] = n), n;
}, xe = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["staffGetMarketingPackageTemplates", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetMarketingPackageTemplates(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, Se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["staffGetMarketingPackageTemplates", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Ce = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["staffGetMarketingPackages", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetMarketingPackages(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, we = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["staffGetMarketingPackages", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Te = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.submitMarketingPackage(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		submitMarketingPackage: d,
		submitMarketingPackagePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ee = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateMarketingPackageTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateMarketingPackageTemplate: d,
		updateMarketingPackageTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, De = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(X), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateMarketingPackageTemplateOrder(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateMarketingPackageTemplateOrder: d,
		updateMarketingPackageTemplateOrderPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { m as DisplayElementElementType, h as DownloadDocumentTypes, g as ElementConditionAndOr, _ as EnvelopeSubmissionModelStatus, v as EnvelopeSubmissionModelType, y as EnvelopeSubmissionRecipientStakeholderType, b as EnvelopeSubmissionRecipientStatus, x as ExpressionOperator, S as FormPageActionButtonType, C as FormPageSubmitType, w as FormState, ee as FormSubmissionRequestState, T as FormType, E as GeneratedDocumentTypes, D as LandAreaDetailsTotalLandAreaType, X as MarketingApiContext, U as MarketingApiException, Z as MarketingApiProvider, p as MarketingClient, O as MarketingItemTemplateBaseModelCategory, k as MarketingItemTemplateBaseModelItemType, A as MarketingItemTemplateModelCategory, j as MarketingItemTemplateModelItemType, M as MarketingItemTemplateModelTemplateType, N as MarketingLaunchDetailsLaunchType, P as MarketingPackageModelCampaignFlowDisplayStatus, F as MarketingPackageProjectionDisplayStatus, G as MarketingRoute, I as PageStatusStatus, L as PropertyDetailsBuiltOnOrVacantLandType, R as PropertyDetailsRuralType, z as SendFormClientDetailsStakeholderType, B as SendFormSubmissionModelState, V as SigningOrderGroups, H as UploadedDocumentDocumentType, Q as useBeginMarketingPackage, te as useCompleteMarketingPackageStep, ne as useCreateMarketingPackageTemplate, re as useDeleteMarketingPackageTemplate, ie as useGetMarketingItemTemplatesForAgent, oe as useGetMarketingPackage, ce as useGetMarketingPackageTemplatesForAgent, ue as useGetMarketingPackages, ae as useInvalidateUseGetMarketingItemTemplatesForAgent, se as useInvalidateUseGetMarketingPackage, le as useInvalidateUseGetMarketingPackageTemplatesForAgent, de as useInvalidateUseGetMarketingPackages, pe as useInvalidateUseLoadMarketingPackageForm, ye as useInvalidateUseStaffGetMarketingItemTemplates, $ as useInvalidateUseStaffGetMarketingPackage, Se as useInvalidateUseStaffGetMarketingPackageTemplates, we as useInvalidateUseStaffGetMarketingPackages, fe as useLoadMarketingPackageForm, Y as useMarketingClientContext, me as useRemoveMarketingPackageSubmission, he as useSaveMarketingPackage, ge as useSendMarketingPackage, _e as useSetMarketingItemTemplates, ve as useStaffGetMarketingItemTemplates, be as useStaffGetMarketingPackage, xe as useStaffGetMarketingPackageTemplates, Ce as useStaffGetMarketingPackages, Te as useSubmitMarketingPackage, Ee as useUpdateMarketingPackageTemplate, De as useUpdateMarketingPackageTemplateOrder };
